import React, { useContext, useEffect, useState } from "react";
import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import DommusLoading from "../../../../../../../components/DommusLoading/DommusLoading";
import './index.css'
import ProcessoService from "../../../../../../../services/ProcessoService";
import { SecaoAditivosContext } from "../../../../../../../contexts/SecaoAditivosContext";
import { DommusAlert } from "../../../../../../../components/DommusAlert";
import { ChamadoContext } from "../../../../../../../components/ContextoGlobal";

export function IframeAditivo() {
  const promiseTelaAditivos = 'busca-url-iframe-aditivos'
  const { promiseInProgress } = usePromiseTracker({ area: promiseTelaAditivos })
  const [urlIframe, setUrlIframe] = useState('')
  const [carregando, setCarregando] = useState(true)
  const { aditivoSelecionado } = useContext(SecaoAditivosContext)
  const { processoTicketSelecionado } = useContext<any>(ChamadoContext)

  useEffect(() => {
    setUrlIframe('')
    buscarUrlIframe()
  }, [])

  function buscarUrlIframe() {
    if(!(carregando)){
      setCarregando(true);
    }
    trackPromise(ProcessoService.buscarUrlIframe(
      processoTicketSelecionado.processo_id,
      aditivoSelecionado?.idx === undefined && undefined || aditivoSelecionado?.idx as any
    )).then(response => setUrlIframe(response.data.url))
      .catch(error => {
        console.log(error)
        console.log(error.response)
        DommusAlert({
          title: 'Ooops...',
          message: 'Houve um erro ao buscar os aditivos.',
          type: 'error'
        })
      })
  }

  useEffect(() => {
    const listener = (event: any) => {
      if (event.data?.type === 'DOMMUS_ADITIVO_FRAME_CARREGADO') {
        setCarregando(false)
      }
    }
    window.addEventListener('message', listener)
    return () => window.removeEventListener('message', listener)
  }, [])

  return <>
    {(promiseInProgress || carregando) && <div className="carregamento-iframe pt-5">
      <DommusLoading loadWrapperPosition="relative" fundo="gainsboro" />
    </div> || <></>}
    <iframe
      className={`${(carregando && 'd-none') || ''} iframe-aditivos`}
      src={urlIframe}
    ></iframe>
  </>
}